module.exports = __webpack_public_path__ + "static/img/图片 26(1).e3a06b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/图片 26(1).png
// module id = SUTZ
// module chunks = 1